/**
 * BOT Cart Popup v2.0
 * Popup centralizado para todos los componentes BOT.
 *
 * Configuracion: viene de window.botPopupConfigs (definido por seccion BOT Popup Config)
 *
 * Uso:
 *   window.botShowCartPopup(product, configName)   configName = 'default', 'promo', etc.
 *   window.botShowCartPopup(product)                usa 'default'
 *   window.botShowCartPopup(product, { ...opts })   config inline (retrocompatible)
 *   window.botCloseCartPopup()
 *   window.botOpenCartDrawer()        -> devuelve true/false
 *   window.botUpdateCartCount()
 */
(function () {
  'use strict';
  if (window.__botCartPopupInit) return;
  window.__botCartPopupInit = true;

  var CSS_INJECTED = false;

  function esc(str) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(str));
    return d.innerHTML;
  }

  function injectCSS() {
    if (CSS_INJECTED) return;
    var s = document.createElement('style');
    s.textContent =
      '#bot-cart-popup{display:none;position:fixed;top:0;left:0;width:100%;height:100%;z-index:99999}' +
      '#bot-cart-popup.is-open{display:flex;justify-content:flex-end;align-items:flex-start}' +
      '.bcp-overlay{position:absolute;inset:0;background:rgba(0,0,0,0.3)}' +
      '.bcp-box{position:relative;max-width:95vw;margin:20px;padding:24px;box-shadow:0 8px 30px rgba(0,0,0,0.15);animation:bcpSlide .3s ease}' +
      '.bcp-close{position:absolute;top:10px;right:12px;background:none;border:none;font-size:22px;cursor:pointer;color:#666}' +
      '.bcp-check{display:flex;align-items:center;gap:8px;margin:0 0 12px;font-size:14px}' +
      '.bcp-check svg{flex-shrink:0}' +
      '.bcp-prod{display:flex;align-items:center;gap:16px;margin:16px 0;padding:16px 0;border-top:1px solid #eee;border-bottom:1px solid #eee}' +
      '.bcp-img{width:80px;height:80px;object-fit:cover;border-radius:4px;background:#f5f5f5}' +
      '.bcp-name{font-size:14px;font-weight:500;line-height:1.4}' +
      '.bcp-actions{display:flex;flex-direction:column;gap:10px;margin-top:8px}' +
      '.bcp-btn{display:block;text-align:center;padding:12px 20px;font-size:14px;font-weight:500;text-decoration:none;cursor:pointer;transition:all .2s;border-width:1px;border-style:solid;box-sizing:border-box}' +
      '.bcp-btn:hover{opacity:.85}' +
      '.bcp-link{background:none;border:none;font-size:13px;cursor:pointer;text-decoration:underline;padding:4px;text-align:center}' +
      '@keyframes bcpSlide{from{opacity:0;transform:translateY(-10px)}to{opacity:1;transform:translateY(0)}}';
    document.head.appendChild(s);
    CSS_INJECTED = true;
  }

  function getConfig(cfgOrName) {
    if (!cfgOrName || cfgOrName === true) cfgOrName = 'default';
    // Si es string, buscar en configs globales
    if (typeof cfgOrName === 'string') {
      var configs = window.botPopupConfigs || {};
      return configs[cfgOrName] || configs['default'] || {};
    }
    // Si es objeto, usar directamente (retrocompatible)
    return cfgOrName;
  }

  function close() {
    var p = document.getElementById('bot-cart-popup');
    if (p) p.classList.remove('is-open');
  }

  function show(product, cfgOrName) {
    var cfg = getConfig(cfgOrName);
    injectCSS();

    var p = document.getElementById('bot-cart-popup');
    if (!p) {
      p = document.createElement('div');
      p.id = 'bot-cart-popup';
      document.body.appendChild(p);
    }

    var bg = cfg.bg || '#ffffff';
    var titleText = cfg.titleText || 'Articulo agregado a tu carrito';
    var titleColor = cfg.titleColor || '#333333';
    var radius = (cfg.radius || 8) + 'px';
    var b1Text = cfg.btn1Text || 'Ver carrito';
    var b1Color = cfg.btn1Color || '#333333';
    var b1Bg = cfg.btn1Bg || 'transparent';
    var b1Border = cfg.btn1Border || '#333333';
    var b2Text = cfg.btn2Text || 'Pagar pedido';
    var b2Color = cfg.btn2Color || '#ffffff';
    var b2Bg = cfg.btn2Bg || '#333333';
    var b2Border = cfg.btn2Border || '#333333';
    var linkText = cfg.linkText || 'Seguir comprando';
    var linkColor = cfg.linkColor || '#666666';
    var btnRadius = (cfg.btnRadius || 4) + 'px';

    var imgSrc = esc(product.image || '');
    var prodName = esc(product.product_title || product.title || '');

    p.innerHTML =
      '<div class="bcp-overlay"></div>' +
      '<div class="bcp-box" style="background:' + bg + ';border-radius:' + radius + ';width:380px">' +
        '<button class="bcp-close">&times;</button>' +
        '<p class="bcp-check" style="color:' + titleColor + '">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2ecc71" stroke-width="3"><path d="M20 6L9 17l-5-5"/></svg>' +
          titleText +
        '</p>' +
        '<div class="bcp-prod">' +
          '<img class="bcp-img" src="' + imgSrc + '" alt="">' +
          '<span class="bcp-name" style="color:' + titleColor + '">' + prodName + '</span>' +
        '</div>' +
        '<div class="bcp-actions">' +
          '<a href="/cart" class="bcp-btn" style="color:' + b1Color + ';background:' + b1Bg + ';border-color:' + b1Border + ';border-radius:' + btnRadius + '">' + b1Text + '</a>' +
          '<a href="/checkout" class="bcp-btn" style="color:' + b2Color + ';background:' + b2Bg + ';border-color:' + b2Border + ';border-radius:' + btnRadius + '">' + b2Text + '</a>' +
          '<button class="bcp-link" style="color:' + linkColor + '">' + linkText + '</button>' +
        '</div>' +
      '</div>';

    p.querySelector('.bcp-overlay').addEventListener('click', close);
    p.querySelector('.bcp-close').addEventListener('click', close);
    p.querySelector('.bcp-link').addEventListener('click', close);
    p.classList.add('is-open');
  }

  function openDrawer() {
    if (typeof openCartDrawer === 'function') { openCartDrawer(); return true; }
    if (typeof window.openCartDrawer === 'function') { window.openCartDrawer(); return true; }
    var drawer = document.getElementById('cart-drawer') || document.getElementById('CartDrawer') || document.querySelector('cart-drawer');
    if (drawer) {
      if (typeof drawer.open === 'function') { drawer.open(); return true; }
      if (typeof drawer.show === 'function') { drawer.show(); return true; }
      if (drawer.classList) { drawer.classList.add('is-open', 'active'); document.body.classList.add('overflow-hidden'); return true; }
    }
    document.dispatchEvent(new CustomEvent('cart:open'));
    return false;
  }

  function updateCount() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var selectors = '[data-cart-count], .cart-count-bubble span, .cart-count, .site-header__cart-count, .header__cart-count, #cart-icon-bubble span';
        document.querySelectorAll(selectors).forEach(function (el) {
          el.textContent = cart.item_count;
          if (el.hidden) el.hidden = false;
          if (el.parentElement && el.parentElement.hidden) el.parentElement.hidden = false;
        });
      });
  }

  // Exponer API global
  window.botShowCartPopup = show;
  window.botCloseCartPopup = close;
  window.botOpenCartDrawer = openDrawer;
  window.botUpdateCartCount = updateCount;
})();
